export default function dialog() {
  return {
    open: false,

    toolbar: { text: '' },

    openDialog() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
    },

    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
    },

    toggleOpen() {
      if (this.open) {
        this.closeDialog();
      } else {
        this.openDialog();
      }
    },
  };
}
